import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const formatApiError = (detail) => {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};

export const rupiah = (v) => "Rp" + new Intl.NumberFormat("id-ID").format(Math.max(0, Math.floor(v || 0)));

export const fileSrc = (url) => (!url ? "" : /^https?:\/\//i.test(url) ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data?.url || "";
};
